module.exports = __webpack_public_path__ + "img/patrimoine2.f5cac01b.jpg";